export default __webpack_public_path__ + "static/char-s-37-zh-Hans-d4a240eb1dc1cd4b607ebbeb41836e43.webp";